import {
  RECALCULATE_PRODUCT_REQUEST,
  RECALCULATE_PRODUCT_SUCCESS,
  RECALCULATE_PRODUCT_FAILURE,
  RECALCULATE_PRODUCT_RESET,
  UPDATE_PET_AND_SWAP_LINE_SUCCESS,
} from '@modules/subscriptions/core/actionTypes';
import { ProductUpdatedState, ProductUpdatedActions } from './types';

const initialState: ProductUpdatedState = {
  pending: false,
  data: null,
  error: null,
};

export const productUpdatedReducer = (
  state = initialState,
  action: ProductUpdatedActions,
): ProductUpdatedState => {
  switch (action.type) {
    case RECALCULATE_PRODUCT_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case RECALCULATE_PRODUCT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.payload.productUpdated ?? null,
        error: null,
      };
    case RECALCULATE_PRODUCT_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case RECALCULATE_PRODUCT_RESET:
    case UPDATE_PET_AND_SWAP_LINE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: null,
        error: null,
      };
    case 'persist/REHYDRATE':
      return {
        ...state,
        pending: false,
        data:
          action.payload && action.payload.productUpdated && action.payload.productUpdated.data
            ? action.payload.productUpdated.data
            : null,
        error: null,
      };
    default:
      return state;
  }
};
